// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions as HelpTicketAction } from '../duck';
import HelpTicket from '../components/HelpTicket';
import { push } from 'react-router-redux';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    locale: state.locale,
    isCreatingTicket: state.helpTicket.isCreatingTicket,
    createTicketSuccessful: state.helpTicket.createTicketSuccessful,
    createTicketError: state.helpTicket.createTicketError,
    user: state.auth.user,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...HelpTicketAction,
    goToRedirect: (route) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpTicket);



// WEBPACK FOOTER //
// ./src/modules/help-ticket/container/HelpTicketContainer.js